import { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import { Card, CardContent } from "./card";

/* 🎨 VARIANTES */
const variants = {
  default: "bg-white/80 dark:bg-slate-800/60 backdrop-blur-sm",
  blue:    "bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800/30",
  amber:   "bg-amber-50 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-800/30",
  red:     "bg-red-50 dark:bg-red-900/20 border border-red-100 dark:border-red-800/30",
  green:   "bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-100 dark:border-emerald-800/30",
};

export default function CollapsibleCard({
  title,
  children,
  right,
  defaultOpen = false,
  icon,
  badge,
  variant = "default",
  empty = false,
  emptyText = "Sin información",
}) {
  const [open, setOpen] = useState(defaultOpen);
  const [height, setHeight] = useState(0);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      setHeight(open ? contentRef.current.scrollHeight : 0);
    }
  }, [open, children]);

  return (
    <Card
      className={`
        rounded-[20px]
        ${variants[variant] || variants.default}
      `}
    >
      <CardContent className="space-y-2">

        {/* 🔹 HEADER */}
        <div
          className="flex items-center justify-between h-11 cursor-pointer transition active:scale-[0.98]"
          onClick={() => setOpen(!open)}
        >
          {/* IZQUIERDA */}
          <div className="flex items-center gap-3">

            {/* ICON */}
            {icon && (
              <div className="w-6 h-6 flex items-center justify-center">
                {icon}
              </div>
            )}

            {/* TITLE */}
            <p className="text-[14px] font-semibold text-slate-800 dark:text-slate-100 tracking-tight">
              {title}
            </p>

            {/* BADGE */}
            {badge !== undefined && (
              <span className="text-[10px] px-2 py-0.5 rounded-full bg-slate-200 dark:bg-slate-700 text-slate-600 dark:text-slate-300">
                {badge}
              </span>
            )}
          </div>

          {/* DERECHA */}
          <div className="flex items-center gap-2">
            {right}

            <ChevronDown
              size={16}
              className={`transition-transform duration-300 text-slate-400 dark:text-slate-500 ${
                open ? "rotate-180" : ""
              }`}
            />
          </div>
        </div>

        {/* 🔹 CONTENT ANIMADO */}
        <div
          style={{ height }}
          className="overflow-hidden transition-all duration-300"
        >
          <div ref={contentRef} className="pt-2 space-y-2">

            {/* EMPTY STATE */}
            {empty ? (
              <p className="text-xs text-slate-400 dark:text-slate-500">
                {emptyText}
              </p>
            ) : (
              children
            )}

          </div>
        </div>

      </CardContent>
    </Card>
  );
}